import { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { Calendar } from '@fullcalendar/core'; // include this line


import { Component, ViewChild, OnInit } from '@angular/core';
import listPlugin from '@fullcalendar/list';
import { EventsService } from '../services/events.service';
import { Router } from '@angular/router';
import { EncrDecrService } from '../services/encr-decr.service';
import { MatButtonToggleChange } from '@angular/material/button-toggle';




@Component({
  selector: 'app-mybookings',
  templateUrl: './mybookings.component.html',
  styleUrls: ['./mybookings.component.scss']
})
export class MybookingsComponent implements OnInit {

  pickedEvents: any[] = []
  eventsList: any[] = [];
  events = []
  toggle = "calendar";

  // FULL CALENDAR DOCUMENTATION https://fullcalendar.io/docs

  calendarViewOptions: CalendarOptions;

  calendarListOptions: CalendarOptions;
  eventsModel: any;
  @ViewChild('fullcalendar') fullcalendar: FullCalendarComponent;


  constructor(private eventService: EventsService, 
    public router: Router, private encDecrService: EncrDecrService) {
    const name = Calendar.name
  }

  showList: boolean = false; // hidden by default
  showCalendar: boolean = true; // hidden by default
  isDisabled: boolean = true

  calendarView() {
    this.showCalendar = !this.showCalendar;
    this.showList = !this.showList;
  }


  listView() {
    this.showList = !this.showList;
    this.showCalendar = !this.showCalendar;
  }

  OnToggleChanged(ev) {
    console.log(ev);
  }

  toggleView(change: MatButtonToggleChange){
    this.toggle = change.value;
  }

  ngOnInit() {
    this.eventService.myPickedEvents().then((res: any) => {
      console.log(res)
     this.pickedEvents = res.picked_events
      for (let i = 0; i < res.picked_events.length; i++) {
        let eventDate
        for (let j=0;j<res.picked_events[i].event.event_dates.length; j++) {
          if(res.picked_events[i].event.event_dates[j].id === res.picked_events[i].event_date_id){
             eventDate = res.picked_events[i].event.event_dates[j].date
          }
        }
        this.eventsList.push({
          id:res.picked_events[i].event_id, 
          title: res.picked_events[i].event.event_name, 
          date: eventDate
        });
      }
      console.log(this.eventsList)
      this.calendarViewOptions = {
        initialView: 'dayGridMonth',
        dateClick: this.handleDateClick.bind(this), // bind is important!
        events: this.eventsList,
        eventClick: this.handleEventClick.bind(this),
        eventBackgroundColor:'#5d2041',
        eventBorderColor:'#77bb00',
        eventTextColor:'white',
    
        
      };
      this.calendarListOptions = {
        plugins: [listPlugin],
        initialView: 'listWeek',
        dateClick: this.handleDateClick.bind(this), // bind is important!
        events: this.eventsList,
        eventClick: this.handleEventClick.bind(this),
        eventBackgroundColor:'#5d2041',
        eventBorderColor:'#77bb00',
        eventTextColor:'white',

      };
    })
      .catch((error) => {
        console.log(error)
      })
  }

  handleDateClick(arg) {
    console.log(arg);
    console.log("date clicked")
  }

  handleEventClick(arg) {
    let pickedEventId = parseInt(arg.event._def.publicId)
    let link
    for (let i=0; i<this.pickedEvents.length; i++){
      if(this.pickedEvents[i].event_id == pickedEventId){
        link = this.pickedEvents[i].event.link
      }
    }
    this.router.navigate(['event', link]);
  }

  handleEventDragStop(arg) {
    console.log(arg);
    console.log("event drag stop")
  }

}